// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/undo-2.js';

import { paths } from '../generated/undo-2';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('undo-2', Original, paths);
